import React, { useState, useEffect } from "react";
import Plus from "../../../../assets/svg/icons/common/Plus";
import Spinner from "../../../../components/Loaders/Spinner";
import Search from "../../../../components/SearchInput/SearchInput";
import Table from "../../../../components/Table";
import Button from "../../../../components/new-button";
import AddSubOrganizationModal from "./components/add-sub-organization-modal";
import EditSubOrganizationModal from "./components/edit-sub-organization-modal";
import useSubOrganizations from "./hooks/useSubOrganizations";
import styles from "./styles.module.scss";
import SubOrgTable from '../sub-organizations/components/table';
import Pagination from "../../../../components/Pagination/Pagination";
import { getSubOrgList, UpdateMember } from "../../../../../api";
import useOrganizationStore from "../../../../stores/organization";
import useCommonStore from "../../../../stores/common";
import useDomainStore from "../../../../stores/domain";
import { useMediaQuery } from "../../../../hooks/useMediaQuery";
import ExpandDetailsIcon from "../../../../assets/svg/icons/common/ExpandDetailsIcon";
import toast from "react-hot-toast";

const SubOrganizations = () => {
  const { isKurvDomain } = useDomainStore();
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const toggleExpandDetails = useCommonStore(
    (state) => state.toggleExpandDetails,
  );
  const {
    subOrgs,
    searchTerm,
    handleSearchTextChange,
    loading,
    searchLoading,
  } = useSubOrganizations();
  const [addSubOrgModalOpen, setAddSubOrgModalOpen] = useState(false);
  const [editSubOrgModalOpen, setEditSubOrgModalOpen] = useState(false);
  const [subOrgId, setSubOrgId] = useState("");
  const [subOrgList, setSubOrgList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const isMobile = useMediaQuery(768);


  const selectedOrganizationId = useOrganizationStore(
    (state) => state.selectedOrganizationId,
  );
  const setSelectedOrganizationData = useOrganizationStore(
    (state) => state.setSelectedOrganizationData,
  );
  
  const handleDeleteMember = (subOrgId, memberId) => {
    setSubOrgList((prev) =>
      prev.map((subOrg) =>
        subOrg.id === subOrgId
          ? {
              ...subOrg,
              members: subOrg.members.filter((m) => m.id !== memberId),
              member_count: subOrg.member_count - 1,
            }
          : subOrg
      )
    );
  };

  const handleEditSubOrg = (subOrgId) => {
    setEditSubOrgModalOpen(true);
    setSubOrgId(subOrgId);
  };

  const fetchSubOrgList = async (silent = false) => {
    if (!silent) {
      setIsLoading(true);
    }
    const response = await getSubOrgList({
      org_id: selectedOrganizationId,
      page: currentPage,
      include_trends: isMobile,
    });
    
    if (response.status) {
      setSubOrgList(response.data.organizations);
      setTotalItems(response.data.pagination.total);
      setPageCount(response.data.pagination.last_page);
    }
    if (!silent) {
      setIsLoading(false);
    }
  };

  const updateMemberStatus = (member, status) => {
    let tempName = member.name.split(" ");
    let firstName = "";
    let lastName = "";
    if (tempName.length > 1) {
      lastName = tempName[tempName.length - 1];
      tempName.pop();
      firstName = tempName.toString().replace(/,/g, " ");
    } else if (tempName.length > 0) {
      firstName = tempName[0];
    }
    member["disabled"] = status;
    member["first_name"] = firstName;
    member["last_name"] = lastName !== "" ? lastName : "placeholder";
    member["sub_org"] = member?.sub_org_id;

    UpdateMember(selectedOrganizationId, member)
      .then((response) => {
        if (response.success) {
          setSelectedOrganizationData((prev) => ({
            ...prev,
            users: response.users,
          }));
          if(response?.users?.length > 0 && member?.sub_org_id ){
            const membersWithSubOrg = response.users.filter(user => user.sub_org_id == member?.sub_org_id);
            setSubOrgList((prev) =>
              prev.map((subOrg) =>
                subOrg.id === member.sub_org_id
                  ? {
                      ...subOrg,
                      members: membersWithSubOrg,
                      member_count: membersWithSubOrg.length,
                    }
                  : subOrg
              )
            );
          }
          toast.success("Member status updated successfully", { duration: 5000 });
        } else {
          toast.error(response.message, { duration: 5000 });
          console.error(response.message);
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Failed to update member status", { duration: 5000 });
      });
  };



  useEffect(() => {
    fetchSubOrgList();
  }, [selectedOrganizationId, currentPage, isMobile]);

  if(!expandDetails) {
    return (
      <div className={styles.minimizeContainer}>
        <button
          className={styles.expandButton}
          onClick={toggleExpandDetails}
        >
          <ExpandDetailsIcon fill={isKurvDomain ? "#22A276" : "#254FE2"} />
          <span style={{ color: isKurvDomain ? "#22A276" : "#254FE2" }}>Expand to view sheet</span>
        </button>
      </div>
      
    )
  }

  return (
    <div className={`${styles.container} ${isKurvDomain ? styles.kurv_theme : ""}`}>
      <div className={styles.header}>
        <Search
          placeholder="Search"
          value={searchTerm}
          onChange={handleSearchTextChange}
        />
        <Button
          variant="primary"
          icon={<Plus />}
          onClick={() => setAddSubOrgModalOpen(true)}
        >
          Add Sub Organization
        </Button>
      </div>

      {loading || searchLoading || isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "32px",
          }}
        >
          <Spinner />
        </div>
      ) : (
        <div className={styles.body} >
          <SubOrgTable data={subOrgList} fetchSubOrgList={fetchSubOrgList} handleDeleteMember={handleDeleteMember} updateMemberStatus={updateMemberStatus} handleEditSubOrg={handleEditSubOrg} />
        </div>
      )}

      {subOrgList.length > 0 && (
        <div className={styles.footer} >
          <Pagination
            pageCount={pageCount}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage - 1}
            onPageChange={({ selected }) => setCurrentPage(selected + 1)}
          />
        </div>
      )}

      <AddSubOrganizationModal
        open={addSubOrgModalOpen}
        onClose={() => {
          setAddSubOrgModalOpen(false);
          fetchSubOrgList();
        }}
      />
      <EditSubOrganizationModal
        open={editSubOrgModalOpen}
        onClose={() => {
          setEditSubOrgModalOpen(false);
          fetchSubOrgList(true);
        }}
        subOrgId={subOrgId}
      />
    </div>
  );
};

export default SubOrganizations;
